module.exports = __webpack_public_path__ + "img/legendary-badge.cef29c8f.png";